(function FitBuilderDaySort($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload(['/FitBuilders/daySort/'], function onload() {
			$('.fb-component-days').each(function _setDraggers(index) {
				dragula([$('.fb-component-days')[index]], {
					revertOnSpill: true,
				})
				.on('drop', function dropIt(this_el, target, source, sibling)
				{
					// handleSortOrder(index);
					handleOverAllSort(index);
				});
			});
		});
	});

	function handleOverAllSort() {
		var day = {};

		$('.fb-component-days').each(function _goThroughDayContainers(q) {
			$(this).find('.fb-component-day').each(function _goThroughDay(i) {
				day = {
					component_id      : $(this).data('component-id'),
					sort_order        : (i + 1),
					day_index         : $(this).data('day-index'),
					current_sort_order: $(this).data('sort-order'),
					time              : $(this).data('time')
				};

				Adzuki.Ajax.post('/FitBuilders/componentSaveSort/', day).then(function success(response) {
					// console.log("did it");
				});
			});
		});

		toastr.success(
			'Sort order saved!',
			null,
			{
				positionClass  : 'toast-top-center',
				timeOut        : 5000,
				extendedTimeOut: 0,
			}
		);
	}

	/**
	function handleSortOrder(index) {
		var $container = $('.fb-component-days[data-index="' + index + '"]'),
			$children  = $container.find('.fb-component-day'),
			data       = {};

		$children.each(function _iterateChildren(i) {
			data[i] = $(this).data('component-id');
		});

		Adzuki.Ajax.post('/FitBuilders/componentSaveSort/', data).then(function success(response) {
			if (response.saved === 'true') {
				Adzuki.StatusMessage('success', 'Sort order saved!');
			}
		});
	}
	**/
}(jQuery, window.Adzuki || {}));